import { RolesWithPermissions } from '../../types';

export const ROLES_DEFINITION = {
  consumer: {
    accounts: {
      view: true,
    },
    contracts: {
      sign: true,
      view: true,
    },
    impersonation: {
      view: false,
    },
    invoices: {
      view: true,
    },
    meteringPoints: {
      view: true,
    },
    producerEvents: {
      view: false,
    },
    protocols: {
      generateInvoice: false,
      view: false,
    },
  },
  producer: {
    accounts: {
      view: true,
    },
    contracts: {
      sign: true,
      view: true,
    },
    impersonation: {
      view: false,
    },
    invoices: {
      view: true,
    },
    meteringPoints: {
      view: true,
    },
    producerEvents: {
      view: true,
    },
    protocols: {
      generateInvoice: true,
      view: true,
    },
  },
  support: {
    accounts: {
      view: true,
    },
    contracts: {
      sign: true,
      view: true,
    },
    impersonation: {
      view: true,
    },
    invoices: {
      view: true,
    },
    meteringPoints: {
      view: true,
    },
    producerEvents: {
      view: true,
    },
    protocols: {
      generateInvoice: true,
      view: true,
    },
  },
} as const satisfies RolesWithPermissions;
